export const EXPERT = 'EXPERT';
export const SPECIALIST = 'SPECIALIST';
export const SPECIALIST_LITE = 'SPECIALIST_LITE';
